export default "__VITE_ASSET__553d0fcd__"